import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-clear-primary-policy-dialog',
  templateUrl: './clear-primary-policy-dialog.component.html',
  styleUrls: ['./clear-primary-policy-dialog.component.scss'],
  standalone:true,
  imports: [
    MatButtonModule, 
    MatDialogModule,
    CommonModule
  ]
})
export class ClearPrimaryPolicyDialogComponent {

  setAsPrimaryPolicy: boolean = true;
  setAsPrimaryPackage: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ClearPrimaryPolicyDialogComponent>
  ) { }

  ngOnInit() {
    if (this.data.component === 'Policy') {
      if (this.data.setAsPrimaryPolicy) {
        this.setAsPrimaryPolicy = true;
      } else {
        this.setAsPrimaryPolicy = false;
      }
    }

    if (this.data.component === 'Verification Package') {
      if (this.data.setAsPrimaryPackage) {
        this.setAsPrimaryPackage = true;
      } else {
        this.setAsPrimaryPackage = false;
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close('cancel');
  }

  onClearPrimaryPolicyClick(): void {
    this.dialogRef.close(this.setAsPrimaryPolicy);
  }

  onSetAsPrimaryPolicyClick(): void {
    this.dialogRef.close(this.setAsPrimaryPolicy);
  }

  onClearPrimaryVerificationPackageClick(): void {
    this.dialogRef.close(this.setAsPrimaryPackage);
  }

  onSetAsPrimaryVerificationPackageClick(): void {
    this.dialogRef.close(this.setAsPrimaryPackage);
  }
}